import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import AppRouter from './Components/Router/AppRouter';

function App() {
  return (
    <div className="App">
     <AppRouter />
    </div>
  );
}

export default App;
